export const ProjectIcon = () => {
  return (
    <svg fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='1'>
        <path
          d='M9.52148 2C10.2929 2 11.0215 2.35602 11.4951 2.96484L13.8604 6.00684C15.3338 6.0294 16.1923 6.13369 16.8262 6.62012C17.0342 6.77971 17.2203 6.96584 17.3799 7.17383C17.9998 7.98175 18 9.15442 18 11.5C18 13.8456 17.9998 15.0183 17.3799 15.8262C17.2203 16.0342 17.0342 16.2203 16.8262 16.3799C16.0183 16.9998 14.8456 17 12.5 17H8C5.17157 17 3.75759 16.9998 2.87891 16.1211C2.00023 15.2424 2 13.8284 2 11V4.5C2 3.11929 3.11929 2 4.5 2H9.52148ZM4.5 3C3.67157 3 3 3.67157 3 4.5V6H12.5889L10.7061 3.5791C10.4219 3.21372 9.98437 3 9.52148 3H4.5Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
